/*
 * Sockets
 *
 * Where the GRACI assistant is served from.
 *
 * THERE IS NO LOCAL VERSION OF THIS, so there is no development branch. The
 * assistant runs on one server and every property talks to that server, whether
 * it is being served from a laptop or from production.
 *
 * Pointing it at localhost in development was wrong twice over: nothing answers
 * on that port, and the browser's attempt to reach it surfaces as a cross
 * origin frame error naming whatever port the dev server happens to be on,
 * which reads like a CORS misconfiguration and is not one.
 *
 * NOT sockets.aftplatform.com either. That is the AFT platform's own socket
 * server, carrying cards, dealerships, flipchart and the rest, and it has no
 * /graci namespace on it at all.
 */

const HOST = 'https://sockets.crosslinkserver.com';
const Sockets = {
  // Overridable per deployment, for the rare case of pointing a staging build
  // at a staging assistant. Left unset it is the one real host.
  url: () => process.env.REACT_APP_SOCKETS_URL || HOST
};
export default Sockets;